import { delay } from '@fxts/core';

export const debounce = <F extends (...args: Parameters<F>) => ReturnType<F>>(f: F, time: number) => {
  let i = 0;
  return async function _debounce(...args: Parameters<F>) {
    const id = await delay(time, ++i);
    return id === i ? f(...args) : void 0;
  };
};
